import type { Filter } from '../../types/filter.types';
import { filterLeaves } from './filter-leaves';
import { compareFieldname } from './filter-utils';

export const removeByField = (source: Filter, targetField: string): Filter | null =>
  filterLeaves(source, leaf => compareFieldname(leaf, targetField));
